<template>
    <div class="px-8 m-auto">
        <h1 class="text-center text-gray-700 dark:text-indigo-400 text-3xl">Painel Varejo Opinião</h1>
        <h1 class="text-center text-gray-500 dark:text-gray-400 text-lg">Cadastro</h1>
        <form novalidate @submit.prevent="register()" class="grid grid-cols-2 gap-x-2 gap-y-4 pt-8">
            <span class="col-span-2">
                <Input label="Nome Completo" type="text" v-model="state.name" :validation="v$.name"/>
            </span>
            <span class="col-span-2 md:col-span-1">
                <Input label="Email" type="email" v-model="state.email" :validation="v$.email"/>
            </span>
            <span class="col-span-2 md:col-span-1 flex gap-x-2">
                <Input label="Telefone" type="phone" v-model="state.phone" :validation="v$.phone"  v-maska="['(##) # ####-####', '(##) ####-####']"/>
                <Input label="Ramal" type="phone" v-model="state.ramal" :validation="v$.ramal" v-maska="'######'"/>
            </span>
            <span class="col-span-2 md:col-span-1">
                <Input label="Senha" type="password" v-model="state.password.password" :validation="v$.password.password"/>
            </span>
            <span class="col-span-2 md:col-span-1">
                <Input label="Senha (confirmação)" type="password" v-model="state.password.confirm" :validation="v$.password.confirm"/>
            </span>
            <p class="col-span-2 text-sm text-indigo-500">Ao finalizar o cadastro, você concorda com todos os <strong>Termos de Uso</strong> do serviço</p>
            <button type="submit" @click.prevent="register()" class="btn col-span-2 bg-indigo-700 h-10 rounded-md uppercase text-gray-50" :disabled="v$.$invalid">Finalizar</button>
        </form>
    </div>
</template>

<script>
import Input from '@/components/Design/Input'
import { reactive, computed, onMounted } from 'vue'
import useVuelidate from '@vuelidate/core'
import { personName, phone, emailValidator, passwordRegistration, ramal } from '@/mixins/validators.js'
import { required, helpers } from '@vuelidate/validators'
import { POST_USUARIO } from '../../mixins/api'
import { displayNotification } from '../../mixins/notification'
import axios from 'axios'

export default {
    name: 'SignUp',
    components: {
        Input
    },
    props: {
        inSystem: {
            default: 0
        }
    },
    setup (props, { emit }) {
        const state = reactive({
            name: '',
            phone: '',
            email: '',
            password: {
                password: '',
                confirm: ''
            },
            ramal: ''
        })
        // Validation
        const rules = computed(() => {
            return {
                name: personName(),
                phone: phone(),
                email: emailValidator(),
                password: {
                    password: passwordRegistration(),
                    confirm: {
                        required:
                            helpers.withMessage('Este campo é obrigatório', required),
                        sameAs:
                            helpers.withMessage('As senhas devem ser iguais', (value) => value === state.password.password)
                    }
                }
            }
        })
        const v$ = useVuelidate(rules, state)

        const register = async () => {
            const body = {
                nome: state.name,
                email: state.email,
                password: state.password.password,
                confirmPassword: state.password.confirm,
                telefone: state.phone.replace('-', '').replace('(', '').replace(')', '').replaceAll(' ', ''),
                ramal: state.ramal,
                role: 'pesquisador',
                ativo: 1
            }

            POST_USUARIO(body).then(r => {
                displayNotification(r)
                if (props.inSystem) {
                    Object.assign(state, {
                        name: '',
                        phone: '',
                        email: '',
                        password: {
                            password: '',
                            confirm: ''
                        },
                        ramal: ''
                    })
                    v$.value.$reset()
                } else {
                    emit('clickToChange', 1)
                }
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        onMounted(async () => {
            await axios.get('/sanctum/csrf-cookie')
        })

        return {
            state,
            v$,
            register
        }
    }
}
</script>

<style>

</style>
